import React, {useEffect, useState} from 'react'
import { v4 as uuidv4 } from 'uuid';
import {  errorAlert } from '../../lib/utils'; 
import {FieldDropdown, NewDeviceField, TextField} from '../';
import {useStateContext} from '../../context/StateContext';
import {BsToggleOn, BsToggle2Off} from 'react-icons/bs';
import {expandReference, keyId } from '../../lib/utils';
import {useCreateReplace} from '../../hooks/mutations'
import {VisDiv} from '../';


/**
 * RegisterNonConformity component.
 * 
 * This component is used to render a button that toggles the presence of a non-conformity in a register.
 * The button is only rendered if the register has a non-conformity field.
 * it is in index.js, used if there are non conformities in the register, not linked to devices. 
 * #unused
 * @param {object} registerTemplate - the register template object.
 * 
 * @returns A React component that renders a button that toggles the presence of a non-conformity in a register.
 */
const RegisterNonConformity = ({registerTemplate}) => {
    const {sUser, register, setRegister, registers, setRegisters} = useStateContext();
    const [singleValue, setSingleValue] = useState()
    useEffect(()=>{
        //console.log(register?.registerNonConformities?.length)
        if(register?.registerNonConformities?.length>0){setSingleValue(true)}
        else {setSingleValue(false)}
    },[register])
    const docId = register?._id
    const nonConfDoc = {
        postedBy: [{ _type: 'postedBy', _ref: sUser._id, _key: keyId(), }], 
        status:"DA FARE",
        _key: keyId(),

        nonConformity:{
            _ref: registerTemplate?.registerFields && registerTemplate?.registerFields[0]?.nonConformities[0]?._ref,
            _type: "reference",
            _key: keyId(),
        }
    }
    const {mutate: updateDevice} = useCreateReplace({
        onError: (err) => {
            console.error('Oh no, the update failed: ', err.message);
            errorAlert("Presidio non aggiornato, riprovare");
        }
        }
    )
    
    const icon = singleValue
        ? <BsToggleOn className="toggle-icon-true-red" />
        : <BsToggle2Off className="toggle-icon-false"/>

    /**
     * Function to toggle the presence of a non-conformity in a register.
     * If the non-conformity is present, it removes it. If it is not present, it adds it.
     * Also updates the state of the register and of the registers array.
     */
    const onClick = () =>{

        if(!singleValue){
            setSingleValue(true)
            //updateDeviceFields(newField)
            updateDevice({doc:{...register, registerNonConformities:[nonConfDoc] }, documentId: register._id})
            setRegister({...register, registerNonConformities:[nonConfDoc] })
            const updatedRegisters = registers.filter?.((x=>x._id!==register._id))
            const newRegisters = [...updatedRegisters,{...register, registerNonConformities:[nonConfDoc] }]
            //console.log("1:", singleValue, "newReg",newRegisters)
            setRegisters([...updatedRegisters,{...register, registerNonConformities:[nonConfDoc] }])
        } else {
            setSingleValue(!singleValue)
            //updateDeviceFields({})
            updateDevice({doc:{...register, registerNonConformities:[] }, documentId: register._id})
            setRegister({...register, registerNonConformities:[] })
            const updatedRegisters = registers.filter?.((x=>x._id!==register._id))
            const newRegisters = [...updatedRegisters,{...register, registerNonConformities:[] }]
            //console.log("2:", singleValue, "non conf", nonConfDoc, "newReg", newRegisters)
            setRegisters([...updatedRegisters,{...register, registerNonConformities:[] }])
        }

    }
    return (
        <VisDiv rules={[registerTemplate?.registerFields?.length>0]} style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <p style={{marginRight:"10px", fontWeight:"bold"}}>
                {singleValue ? registerTemplate?.registerFields && registerTemplate?.registerFields[0].label : registerTemplate.registerFields && registerTemplate.registerFields[0]?.conformityLabel}
            </p>
            <button 
                type="button"
                onClick={()=>{
                    onClick()
                }}
                className="toggle-button"
            >
                    {icon}
                </button>
    
        </VisDiv>
    )
}

export default RegisterNonConformity
